var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxiconsBriefcase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 3.9987H11.3335V2.66536C11.3335 1.93203 10.7335 1.33203 10.0002 1.33203H6.00016C5.26683 1.33203 4.66683 1.93203 4.66683 2.66536V3.9987H2.66683C1.9335 3.9987 1.3335 4.5987 1.3335 5.33203V13.332C1.3335 14.0654 1.9335 14.6654 2.66683 14.6654H13.3335C14.0668 14.6654 14.6668 14.0654 14.6668 13.332V5.33203C14.6668 4.5987 14.0668 3.9987 13.3335 3.9987ZM6.00016 2.66536H10.0002V3.9987H6.00016V2.66536ZM2.66683 13.332V5.33203H13.3335V13.332H2.66683Z",
    fill: "#25262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxiconsBriefcase);
export default __webpack_public_path__ + "static/media/boxicons_briefcase.9060dba8ad5bfcf27b81e380a823e652.svg";
export { ForwardRef as ReactComponent };